export enum ActivityDocumentSaveOption {
  'SEND_EMAIL' = 'SEND_EMAIL',
  'SEND_FAX' = 'SEND_FAX',
  'UPLOAD_ATTACHMENT' = 'UPLOAD_ATTACHMENT',
  'ADD_KNOSTOS_DOCUMENT' = 'ADD_KNOSTOS_DOCUMENT',
  'SEND_FOR_SIGNATURE' = 'SEND_FOR_SIGNATURE',
}
